import Vue from 'vue';
import './directives/focus';

Vue.config.productionTip = false;

// Force polyfill to be available
window.Promise = Promise;
